export const useEstimatedReadingTime = (text: string) => {
  if (!text) {
    return { minutes: 0 }
  }

  const words = text.split(' ').length ?? 0
  const minutes = Math.ceil(words / 220)

  return { minutes }
}
